<template>
  <div class="noPermisson">
    <img src="../../assets/images/noper.png" alt="无权限" class="noPer"/>
    <div style="margin:24px 0;font-size:16px;">当前登录钉钉账号：{{ params.nick }}</div>
    <div v-if="is_bind" style="width: 500px;margin: 20px auto">
      <div style="margin:24px 0;font-size:14px;color: #606266">请输入已有的登录账号用户名</div>
      <el-input type="text" v-model="params.account" placeholder="请输入登录账号用户名或邮箱"
                suffix-icon="el-icon-user-solid" class="input1"/>
      <el-input type="password" v-model="params.password" placeholder="请输入登录密码" style="margin-top: 5px;"
                suffix-icon="el-icon-lock"
                @keyup.enter.native="sure"/>
      <div class="err">
        {{ errMessage }}
      </div>
      <br/>
      <br/>
      <el-button type="danger" style="display: block;width: 100%" :disabled="!params.account||!params.password"
                 @click="sure">确认绑定
      </el-button>
      <el-button type="info" style="display: block;width: 100%;margin-left: 0;margin-top: 10px"
                 @click="is_bind=false">上一步
      </el-button>
    </div>
    <div v-else>
      <div style="margin:24px 0;font-size:14px;color: #606266">钉钉首次扫码登录，还未绑定平台自有账户</div>
      <!--      <el-button type="info" @click="sure">不需要绑定，注册新账号</el-button>-->
      <el-button type="primary" @click="register">同步钉钉用户信息并注册新账号</el-button>
      <el-button type="danger" @click="is_bind=true">绑定已有帐号</el-button>
    </div>
  </div>
</template>

<script>
import {bindDingDing, getAuth} from '@/api/login'

export default {
  name: 'login',
  data() {
    return {
      username: '-',
      is_bind: false,
      params: {
        is_bind: false,
        nick: '',
        account: '',
        unionid: '',
        openid: '',
      },
      errMessage: ''
    }
  },
  mounted: function () {
    this.redirect = this.$route.query.redirect || '/';
    this.params = localStorage.getItem('userDingDing') ? JSON.parse(localStorage.getItem('userDingDing')) : false;
  },
  methods: {
    register() {
      //
      let unionId=this.params.unionid||this.params.unionId
      let openid=this.params.openid||this.params.openId
      if (unionId)
        this.$router.push({
          name: 'dingtalk-register',
          params: {unionid: unionId},
          query: {openid:openid}
        })
      else
        this.$notify.warning('钉钉信息丢失无法操作，请返回！！！')
    },
    sure: function () {
      this.params.is_bind = this.is_bind
      bindDingDing(this.params).then(res => {
        if (res.success) {
          if (!res.model.is_register) {
            // 已有账号 直接登录
            this.$store.dispatch('login', res.model);
            this.loginSuccess(res);
            this.$message.success('操作成功')
          } else {
            // 无账号 前往绑定页面
            this.$message.success('绑定成功')
            this.$router.push({path: '/bindDingDing', query: {username: res.model.user_name}});
          }
        }
        // else {
        //   this.$message.error(res.message)
        //   this.$router.push({path: '/login'});
        // }
      });
    },
    // 登录成功后
    loginSuccess: function (val) {
      let user = {};
      getAuth().then(res => {
        user = Object.assign({}, res.model, val.model);
        this.$store.dispatch('login', user);
        if (user.permissions.show_summary_sale || user.permissions.show_summary_data || user.permissions.show_summary_executor) {
          this.$router.push({name: 'homeOld'});
        } else if (user.permissions.manage_menu_adv_order) {
          this.$router.push({name: 'ad-order'});
        } else {
          if (user.permissions.length === 0) {
            this.$router.push({path: '/noPermisson'});
          } else {
            this.$router.push({path: '/'});
          }
        }
      })
      // getAuth().then(res => {
      //     user = Object.assign({}, res.model, val.model);
      //     this.$store.dispatch('login', user);
      //     if (user.permissions.show_summary_sale || user.permissions.show_summary_data || user.permissions.show_summary_executor) {
      //         this.$router.push({path: '/home'});
      //     } else if (user.permissions.manage_menu_adv_order) {
      //         this.$router.push({path: '/ad'});
      //     } else {
      //         let menu = Routers.routes
      //         for (let i = 1; i < menu.length; i++) {
      //             if ((user.permissions[menu[i].meta.auth] || menu[i].meta.auth == 'normal') && !menu[i].meta.hidden) {
      //                 if (menu[i].children && menu[i].children.length) {
      //                     for (let j = 0; j < menu[i].children.length; j++) {
      //                         if ((user.permissions[menu[i].children[j].meta.auth] || menu[i].children[j].meta.auth == 'normal') && !menu[i].children[j].meta.hidden) {
      //                             this.$router.push({path: menu[i].children[j].path});
      //                             return
      //                         }
      //                     }
      //                 } else {
      //                     this.$router.push({path: menu[i].path});
      //                     return;
      //                 }
      //             }
      //         }
      //         this.$router.push({path: '/noPermisson'});
      //     }
      // })
    },
  }
}
</script>

<style scoped>
.noPermisson {
    margin-top: 10%;
    text-align: center;
}

.noPer {
    width: 173px;
    height: 134px;
}

</style>
<style>
</style>
